export type LandingVariant = {
  homePath: string;
  checkoutPath: string;
  trialDays: number;
  promoBanner?: string;
};

/** Public signup is 14-day Betfair trial only (see /start-checkout redirect). */
export const DEFAULT_LANDING_VARIANT: LandingVariant = {
  homePath: '/',
  checkoutPath: '/start-checkout/betfair',
  trialDays: 14,
};

export const BETFAIR_LANDING_VARIANT: LandingVariant = {
  homePath: '/betfair',
  checkoutPath: '/start-checkout/betfair',
  trialDays: 14,
  promoBanner: 'Exclusive Betfair Promotion: 14 Day Free Trial',
};
